/* Scope 3: fifteen categories, a decision for each. No quantity appears in the category table. */

.note {
  margin: 0 0 8px;
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
}

.moreButton {
  margin: 0 0 8px;
  font: inherit;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink);
  background: var(--panel);
  border: 1px solid var(--line-2);
  border-radius: 7px;
  padding: 6px 12px;
  cursor: pointer;
}

.moreButton:disabled {
  color: var(--muted);
  cursor: default;
}

.count {
  margin: 0 0 10px;
  font-size: var(--t-dense);
  font-weight: 650;
  color: var(--ink);
}

.warn {
  margin: 8px 0;
  padding: 8px 10px;
  border: 1px solid var(--warn-line);
  border-radius: 8px;
  background: var(--warn-w);
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--warn);
}

/* Visually quiet: the heading is the panel's, and the caption exists for a screen reader. */
.caption {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* A wide table scrolls inside its own box, never the page (the phone-width rule). */
.scroll {
  min-width: 0;
  overflow-x: auto;
}

.table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
  font-size: var(--t-min);
}

.table thead th {
  text-align: left;
  font-size: var(--t-min);
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--muted);
  padding: 0 8px 6px 0;
  border-bottom: 1px solid var(--line);
}

.table td,
.table .rowHead {
  padding: 7px 8px 7px 0;
  border-bottom: 1px solid var(--line);
  vertical-align: top;
  color: var(--ink);
}

.rowHead {
  font-weight: 400;
  text-align: left;
}

/* Deliberately not the critical colour: nobody has answered, which is not a fault somebody caused. */
.unassessed {
  font-weight: 600;
  color: var(--warn);
}

.basis {
  color: var(--ink-2);
}

.method {
  display: block;
  color: var(--muted);
}

/* Who decided, and when (S25). Quiet: it qualifies the decision, it is not the decision. */
.provenance {
  display: block;
  color: var(--muted);
}

/* A decision that lost to a colleague's (S25). The warn treatment, not the critical one: the form
   was right and nothing is broken - somebody else got there first. */
.conflict {
  display: grid;
  gap: 8px;
  justify-items: start;
  margin: 0;
  padding: 8px 10px;
  border: 1px solid var(--warn-line);
  border-radius: 8px;
  background: var(--warn-w);
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--warn);
}

.conflict p {
  margin: 0;
}

/* The decision form (S18). Tokens only; no colour literal outside tokens.css (ADR-0007). */

.open {
  padding: 3px 9px;
  font: inherit;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink);
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: 6px;
  cursor: pointer;
}

.open:hover {
  background: var(--line-2);
}

.panelCell {
  padding: 0 0 12px;
  border-bottom: 1px solid var(--line);
}

.form {
  display: grid;
  gap: 10px;
  margin: 6px 0 0;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--panel);
}

.fieldset {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  font-size: var(--t-min);
  font-weight: 650;
  color: var(--ink);
}

.option {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: var(--t-min);
  color: var(--ink);
}

.means {
  display: block;
  color: var(--ink-2);
}

.reason {
  display: grid;
  gap: 4px;
}

.textarea {
  font: inherit;
  font-size: var(--t-min);
  padding: 6px 8px;
  border: 1px solid var(--line);
  border-radius: 5px;
  background: var(--panel);
  color: var(--ink);
  resize: vertical;
}

.buttons {
  display: flex;
  gap: 8px;
}

.recorded {
  margin: 8px 0;
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink);
}

.ghost {
  padding: 6px 11px;
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  color: var(--ink-2);
  background: var(--panel);
  border: 1px solid var(--line-2);
  border-radius: 6px;
  cursor: pointer;
}

/* What is on record, shown inside a conflict (gate 19): the colleague's decision the person has not
   yet seen, set apart from the warning sentence above it. Tokens only (ADR-0007). */
.onRecord {
  display: grid;
  gap: 2px;
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: var(--panel);
  color: var(--ink);
}
